import axios from "axios";
import alert from "@/lang/AlertMessages.js";
import label from "@/lang/StaticLabels.js";

export default {
  // LastNews Actions .......................................................
  getHadith({ dispatch, commit }) {
    axios
      .get("Hadiths/GetHadith")
      .then((res) => {
        commit("setHadith", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getAllNews({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get("News/AllNews?" + data)
      .then((res) => {
        commit("setAllNews", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getLastNews({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get("News/LastNews")
      .then((res) => {
        commit("setLastNews", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getChooseNews({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get("News/ChooseNews")
      .then((res) => {
        commit("setChooseNews", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getMoreLikeNews({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get("News/MoreLikeNews")
      .then((res) => {
        commit("setMoreLikeNews", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getMoreViewNews({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get("News/MoreViewNews")
      .then((res) => {
        commit("setMoreViewNews", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getNewestNews({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get("News/NewestNews")
      .then((res) => {
        commit("setNewestNews", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getOneNews({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get("News/GetOneNews?" + data)
      .then((res) => {
        commit("setOneNews", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getLastProvinceNews({ dispatch, commit }, data) {
    axios
      .get("News/LastProvinceNews?" + data)
      .then((res) => {
        commit("setLastProvinceNews", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getElectronicServices({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get("ElectronicServices")
      .then((res) => {
        commit("setElectronicServices", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getNewsGroups({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get("News/NewsGroups")
      .then((res) => {
        commit("setNewsGroups", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  //likes Actions .......................................................
  addLikeAndDisLike({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("News/AddLike?" + data)
      .then((res) => {
        commit("setLiks", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submitLike,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 500);
      });
  },
  // NewsLetters Actions .......................................................
  addNewsLetters({ dispatch, commit }, data) {
    axios
      .post("NewsLetters", data)
      .then((res) => {
        commit("setNewsLetters", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.registeration,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  // contactUs Actions .......................................................
  getContactUs({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get("ContactUs/GetContactUs")
      .then((res) => {
        commit("setContactUs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  addContactUs({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("ContactUs/AddContactUs", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.addComment,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  //Introductions Actions .......................................................
  getIntroductions({ dispatch, commit }) {
    axios
      .get("Introductions/GetIntroductions")
      .then((res) => {
        commit("setIntroductions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getOneIntroduction({ dispatch, commit }, data) {
    axios
      .get("Introductions/GetOneIntroduction?Id=" + data)
      .then((res) => {
        commit("setOneIntroduction", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  //Links Actions .......................................................
  getLinks({ dispatch, commit }) {
    axios
      .get("Links")
      .then((res) => {
        commit("setLinks", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  //Slider Actions .......................................................
  getSliders({ dispatch, commit }, data) {
    axios
      .get("Sliders?" + data)
      .then((res) => {
        commit("setSlider", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  //Banner Actions .......................................................
  getBanners({ dispatch, commit }, data) {
    axios
      .get("Banners?" + data)
      .then((res) => {
        commit("setBanner", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  //Zones Actions .......................................................
  getZones({ dispatch, commit }) {
    axios
      .get("Zones")
      .then((res) => {
        commit("setZones", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // Subjects Actions......................................................
  getSubjectsGroups({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get("Subjects/Groups")
      .then((res) => {
        commit("setGroups", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getLastSubjects({ dispatch, commit }, data) {
    axios
      .get("Subjects/LastSubjects?" + data)
      .then((res) => {
        commit("setLastSubjects", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getChooseSubjects({ dispatch, commit }) {
    axios
      .get("Subjects/ChooseSubjects")
      .then((res) => {
        commit("setChooseSubjects", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMoreLikeSubjects({ dispatch, commit }) {
    axios
      .get("Subjects/MoreLikeSubjects")
      .then((res) => {
        commit("setMoreLikeSubjects", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMoreviewSubjects({ dispatch, commit }) {
    axios
      .get("Subjects/MoreviewSubjects")
      .then((res) => {
        commit("setMoreviewSubjects", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getNewestSubjects({ dispatch, commit }) {
    axios
      .get("Subjects/NewestSubjects")
      .then((res) => {
        commit("setNewestSubjects", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAllSubjects({ dispatch, commit }, data) {
    axios
      .get("Subjects/AllSubjects?" + data)
      .then((res) => {
        commit("setAllSubjects", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getOneSubjects({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true }
    );
    axios
      .get("Subjects/GetOneSubjects?" + data)
      .then((res) => {
        commit("setGetOneSubjects", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
};
